module.exports = __webpack_public_path__ + "images/company/history/history_button_left_big.jpg";